import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ButtonCommonTopNew } from "../../pages/Theme";

const ShowcaseReorder = ({ showcase, onClose,index, onSave }) => {
  const [items, setItems] = useState(showcase); // full list (deleted + non-deleted)

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    // reorder within the FULL items array
    const newItems = Array.from(items);
    const [movedTask] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, movedTask);

    setItems(newItems);
  };

  const handleSave = () => {
    if (onSave) {
      const orderedItems = items.map((data, index) => ({
        showcase_id: data.id,
        sort_order: index + 1,
        name: data.name,
      }));
      const showcaseId = showcase[index]?.id;

      const showcaseNewIndex = orderedItems.findIndex(
        (t) => t.showcase_id === showcaseId
      );

      onSave(orderedItems,showcaseNewIndex);
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="pt-2 rounded-lg">
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="showcase">
          {(provided, snapshot) => (
            <ul
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={`space-y-2 transition-colors ${
                snapshot.isDraggingOver ? "" : "cardBackgroundColor"
              }`}
            >
              {items.map((items, index) => (
                <Draggable
                  key={index.toString()}
                  draggableId={index.toString()}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`p-4 rounded-md cursor-grab active:cursor-grabbing flex items-center text-sm font-medium
                          ${
                            snapshot.isDragging
                              ? "blueBackGroundColorDraggable border shadow-lg scale-105 rotate-2"
                              : "grayBackGroundColorNonDraggable border shadow-sm transition-colors duration-150"
                          }`}
                    >
                      <span
                        className={`${
                          snapshot.isDragging ? "text-white" : "blackColor"
                        } mr-3 text-lg`}
                      >
                        ⋮⋮
                      </span>
                      <span
                        className={`text-sm mt-0.5 ${
                          snapshot.isDragging ? "text-white" : "blackColor"
                        }`}
                      >
                        {items.name}
                      </span>
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>

      <div className="pt-4 flex items-center justify-center">
        <ButtonCommonTopNew
          className="px-5 border p-2 text-sm rounded-lg cursor-pointer"
          onClick={handleSave}
        >
          Update
        </ButtonCommonTopNew>
      </div>
    </div>
  );
};

export default ShowcaseReorder;
